module.exports = "https://r.nearpod.com/assets/media/image/npp_play-c5f13abc412e0c6fafa5db0bca5e04e7.svg";